export const MarkRole = 'mark';
export const FrameRole = 'frame';
export const ScopeRole = 'scope';

export const AxisRole = 'axis';
export const AxisDomainRole = 'axis-domain';
export const AxisGridRole = 'axis-grid';
export const AxisLabelRole = 'axis-label';
export const AxisTickRole = 'axis-tick';
export const AxisTitleRole = 'axis-title';

export const LegendRole = 'legend';
export const LegendBandRole = 'legend-band';
export const LegendEntryRole = 'legend-entry';
export const LegendGradientRole = 'legend-gradient';
export const LegendLabelRole = 'legend-label';
export const LegendSymbolRole = 'legend-symbol';
export const LegendTitleRole = 'legend-title';

export const TitleRole = 'title';
export const TitleTextRole = 'title-text';
export const TitleSubtitleRole = 'title-subtitle';
